<template>
  <v-main v-if="loading && !forcePage" style="width:1920px;height:1080px;">
    <v-progress-circular
      :size="230"
      :width="20"
      :color="color1"
      indeterminate
      style="margin-left: 845px;margin-top:425px;opacity:50%;"
    />
  </v-main>
    <v-main v-else-if="isBannerScroll">
    <div
      :style="{ width: `${width}px` }"
    >
      <activity-page-banner-scroll
        v-if="pages && pages.length > 0"
        :activities="pages[0]"
        :titleDate="titleDate"
        :titleInfo="titleInfo"
        :color1="color1"
        :color2="color2"
        :cols="cols"
        :width="width"
        :height="height"
        :interval="interval"
      />
    </div>
    </v-main>
    <v-main v-else>
      <!--activity-page-row 
        v-if="isRow && pages && pages.length === 1"
        :activities="pages[0]"
        :titleDate="titleDate"
        :titleInfo="titleInfo"
        :color1="color1"
        :color2="color2"
        :cols="cols"
      />
      <activity-page-card 
        v-if="!isRow && pages"
        :activities="pages[0]"
        :titleDate="titleDate"
        :titleInfo="titleInfo"
        :color1="color1"
        :color2="color2"
      /-->
      <v-carousel
        v-if="pages && pages.length"
        cycle
        light
        :width="width"
        :height="height"
        hide-delimiters
        :show-arrows="false"
        style="background-color: transparent !important;"
        :interval="interval"
      >
        <v-carousel-item
          v-for="(page, index) in pages"
          :key="index"
          :style=" { width: `${width}px !important` }"
        >
          <v-sheet
            style="background-color: transparent !important;"
          >
            <activity-page-banner
              v-if="isBanner"
              :activities="page"
              :titleDate="titleDate"
              :titleInfo="titleInfo"
              :color1="color1"
              :color2="color2"
              :cols="cols"
              :width="width"
              :height="height"
            />
            <activity-page-row
              v-else-if="isRow"
              :activities="page"
              :titleDate="titleDate"
              :titleInfo="titleInfo"
              :color1="color1"
              :color2="color2"
              :cols="cols"
              :width="width"
              :height="height"
            />
            <activity-page-card 
              v-else
              :activities="page"
              :titleDate="titleDate"
              :titleInfo="titleInfo"
              :color1="color1"
              :color2="color2"
              :width="width"
              :height="height"
            />
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
      <no-pages v-else-if="!forcePage && (!pages || pages.length === 0)" wrap style="padding:100px"/>
      <!--v-layout v-else-if="!pages || pages.length === 0" wrap style="padding:100px">
        <v-flex
          xs12
          class="textAlert"
          :style="{ color: color1 }"
        >
          <center><b>NO HAY MÁS ACTIVIDADES PROGRAMADAS<br>PARA EL DÍA</b></center>
        </v-flex>
      </v-layout-->
    </v-main>
</template>

<script>
import axios from 'axios'
import utils from '@/services/utils'
import '@descubreDev/dg-activities/dg-activities.css'
import ActivityPageCard from '@/components/lib/activityPageCard/Index'
import ActivityPageRow from '@/components/lib/activityPageRow/Index'
import ActivityPageBanner from '@/components/lib/activityPageBanner/Index'
import ActivityPageBannerScroll from '@/components/lib/activityPageBannerScroll/Index'
//import { ActivityPageCard, ActivityPageRow } from '@descubreDev/dg-activities'
import NoPages from './NoPages'

// ?zoom=80&hotel=34&addDays=1&c1=tomato&c2=blue&c5=red&folder=wantudu

export default {
  name: 'Acttiv',

  components: {
    ActivityPageCard,
    ActivityPageRow,
    ActivityPageBanner,
    ActivityPageBannerScroll,
    NoPages,
  },

  data: () => ({
    //
    loading: true,
    titleDate: null,
    titleInfo: null,
    pages: null,
    activities: null,
  }),
  computed: {
    interval () {
      const aux = utils.getParameterByName('interval')
      return aux ? aux : 10000
    },

    width () {
      const aux = utils.getParameterByName('w')
      return aux ? aux | 0 : 1920
    },
    height () {
      const aux = utils.getParameterByName('h')
      return aux ? aux | 0 : 1080
    },
    isRow () {
      return utils.getParameterByName('type') === 'row'
    },
    isForceDate () {
      return utils.getParameterByName('fd') ? true : false
    },
    isBannerScroll () {
      return utils.getParameterByName('type') === 'bannerscroll'
    },
    isBanner () {
      return utils.getParameterByName('type') === 'banner'
    },

    cols () {
      return utils.getParameterByName('cols') | 0
    },
    rows () {
      const aux = utils.getParameterByName('rows')
      return aux ? aux | 0 : 3
    },
    showAll () {
      return utils.getParameterByName('showAll')
    },
    marginLeft () {
      return utils.getParameterByName('ml')
    },
    marginTop () {
      return utils.getParameterByName('mt')
    },
    color1 () {
      return utils.getParameterByName('c1') ? '#'.concat(utils.getParameterByName('c1')) : '#02443C'
    },
    color2 () {
      return utils.getParameterByName('c2') ? '#'.concat(utils.getParameterByName('c2')) : '#BF9D5A'
    },
    bgcolor () {
      return utils.getParameterByName('c5') ? '#'.concat(utils.getParameterByName('c5')) : null
    },
    folder () {
      return utils.getParameterByName('folder')
    },
    zoom () {
      let aux = utils.getParameterByName('zoom')
      aux = aux && aux.length > 0 ? parseInt(aux) : null
      return aux ? aux / 100 : null
    },
    id () {
      return utils.getParameterByName('id')
    },
    locale () {
      const aux = utils.getParameterByName('locale')
      return aux ? aux : 'es'
    },
    date() {
      const addDays = utils.getParameterByName('addDays')
      if (addDays) {
        let aux = new Date()
        aux.setDate(aux.getDate() + parseInt(addDays))
        return aux
      }
        
      let aux = utils.getParameterByName('date')
      if (!aux || aux.length === 0) aux = new Date()
      return aux
    },
    type () {
      const aux = utils.getParameterByName('type')
      return aux ? `&type=${aux}` : ''
    },
    forcePage () {
      const aux = utils.getParameterByName('page')
      return aux ? true : false
    },
    page () {
      const aux = utils.getParameterByName('page')
      return aux ? aux | 0 : null
    },
    typeTitle () {
      const aux = utils.getParameterByName('typeTitle')
      return aux && aux.length > 0 ? aux  : null
    },
  },
  mounted () {
    this.loading = true
    if (this.marginLeft) document.getElementById('app').style.marginLeft = this.marginLeft.concat('px')
    if (this.marginTop) document.getElementById('app').style.marginTop = this.marginTop.concat('px')

    if (this.zoom) {
      document.body.style.zoom = this.zoom
      document.body.style.MozTransform = `scale(${this.zoom})`
      document.body.style.WebkitTransform = `scale(${this.zoom})`
      document.body.style.transformOrigin = 'left top'
    }
    if (this.bgcolor) document.body.style.backgroundColor = this.bgcolor

    this.titleInfo = ''
    const d = new Date(this.date)
    this.titleDate = `${this.getDay()} ${d.getDate()}/${d.getMonth()+1}`

    if (this.id) this.getActivities()
  },
  methods: {
    getActivities () {
      const url = `https://www.dviewcontent.com/api/p_activity/${this.id}/dtouch?config=true&daysToAdd=${utils.getParameterByName('addDays')}${this.type}`
      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
      .then(response => {
        if (response && response.status === 200  && response.data) {
          const { config, activities } = response.data
          this.titleInfo = config.Title[this.locale.toUpperCase()] ? config.Title[this.locale.toUpperCase()] : config.Title['ES']
          if (this.typeTitle) this.titleInfo += ` - ${this.typeTitle}`
          const result = activities.map(item => {
              let subtitle = item.Description[this.locale] ? item.Description[this.locale] : item.Description['es']
              // request of IVAN
              if (this.id === 'f8ed0340-04cb-11f0-92cf-992ebe17071f') {
                subtitle = item.Place[this.locale] ? item.Place[this.locale] : item.Place['es']
              }
            return {
              title: item.Title[this.locale] ? item.Title[this.locale] : item.Title['es'],
              image: item.Image,
              time: `${item.TimeStart.slice(0, 5)} - ${item.TimeEnd.slice(0, 5)}`,
              subtitle,//: item.Description[this.locale] ? item.Description[this.locale] : item.Description['es'],
              active: this.getIsActive(item.TimeStart.slice(0, 5), item.TimeEnd.slice(0, 5)),
              old: this.getIsOld(item.TimeEnd.slice(0, 5)),
            }
          }).filter(x => !x.old || this.showAll)

          
            const pages = []
          if (this.isBannerScroll) {
            this.pages = []
            this.pages[0] = result
      } else if (this.isBanner) {
        let aux = []
        for (const item of result) {
          aux.push(item)
          if (aux.length === (this.rows)) {
            pages.push(aux)
            aux = []
          }
        }
        if (aux.length > 0 ) pages.push(aux)
            this.pages = pages
      } else {
            let aux = []
            for (const item of result) {
              aux.push(item)
              if (aux.length === (this.rows * 2)) {
                pages.push(aux)
                aux = []
              }
            }
            if (aux.length > 0 ) pages.push(aux)

            if (this.forcePage) {
              if (this.page + 1 > pages.length) console.log('error: no page')//alert('aaa')
              this.pages = [pages[this.page]]
            } else this.pages = pages
          }

          this.loading = false
        }
      })
      .catch(error => {
        console.log('err', error)
      }) 
    },
    getIsToday() {
      if (this.isForceDate) return false
      return this.formatDate(this.date) === this.formatDate(new Date()) ? true : false
    },
    getIsTomorrow() {
      if (this.isForceDate) return false
      const aux = new Date()
      aux.setDate(aux.getDate() + 1)
      return this.formatDate(this.date) === this.formatDate(aux) ? true : false
    },
    formatDate(date, short) {
      const d = new Date(date)
      let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()
    
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
    
      if (short) return [day, month].join('/')
      else return [year, month, day].join('-')
    },
    getFirstDay () {
      const d = new Date(this.date)
      const day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1) // adjust when day is sunday
      return this.formatDate(new Date(d.setDate(diff)))
    },
    getDay () {
      if(this.locale === 'en') return this.getIsToday() ? ' TODAY ' : this.getIsTomorrow() ? ' TOMORROW ' : ' '
      else if(this.locale === 'ca') return this.getIsToday() ? ' AVUI ' : this.getIsTomorrow() ? ' MATÍ ' : ' '
      else if(this.locale === 'de') return this.getIsToday() ? ' HEUTE ' : this.getIsTomorrow() ? ' MORGEN ' : ' '
      else if(this.locale === 'fr') return this.getIsToday() ? " AUJOURD'HUI " : this.getIsTomorrow() ? ' MATIN ' : ' '

      return this.getIsToday() ? ' HOY ' : this.getIsTomorrow() ? 'MAÑANA' : ' '
    },
    getIsActive(st, et) {
      if (this.isForceDate) return false
      const start = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), st.split(':').shift(), st.split(':').pop())
      const end = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), et.split(':').shift(), et.split(':').pop())
      return start <= new Date() && end >= new Date()
    },
    getIsOld(v) {
      if (this.isForceDate) return false
      const end = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), v.split(':').shift(), v.split(':').pop())
      return end < new Date() ? true : false
    },
    urlExists(url) {
      try {
        const http = new XMLHttpRequest()
        http.open('HEAD', url, false)
        http.send()
        return http.status != 404
      } catch {
        return false
      }
    },
  },
}
</script>

<style scoped>
#app {
  background: none;
}
</style>

